export const employeeId = 'employeeId';
export const branchKey = 'branch';

export const getEmployeeId = () => sessionStorage.getItem(employeeId);
export const setEmployeeId = (id: string) => sessionStorage.setItem(employeeId, id);
export const removeEmployeeId = () => sessionStorage.removeItem(employeeId);

export const getBranch = () => localStorage.getItem(branchKey);
export const setBranch = (branch: string) => localStorage.setItem(branchKey, branch);
export const removeBranch = () => localStorage.removeItem(branchKey);

export const setLanguage = (lang: string) => localStorage.setItem('lang', lang);
export const getLanguage = () => localStorage.getItem('lang');
export const removeLanguage = () => localStorage.removeItem('lang');
